
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_r0i6w_99",
  "breadcrumb": "awsui_breadcrumb_1kosq_r0i6w_103",
  "icon": "awsui_icon_1kosq_r0i6w_106",
  "anchor": "awsui_anchor_1kosq_r0i6w_111",
  "last": "awsui_last_1kosq_r0i6w_157",
  "compressed": "awsui_compressed_1kosq_r0i6w_167",
  "text": "awsui_text_1kosq_r0i6w_171",
  "virtual-item": "awsui_virtual-item_1kosq_r0i6w_178"
};
  